import React, { useState, useEffect, useRef } from "react";
import {
  IconButton,
  Slider,
  Typography,
  useMediaQuery,
  Button,
} from "@mui/material";
import { PlayArrow, Pause, Delete, Save } from "@mui/icons-material";
import { styled } from "@mui/system";

const AudioPlayer = ({
  audioFile,
  duration,
  redoFunction,
  showSave,
  showControl,
  handleSave,
  sliderColor,
}) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [fileLength, setfileLength] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const audioRef = useRef(null);
  const isSmallScreen = useMediaQuery("(max-width: 600px)");
  const StyledSlider = styled(Slider)(({ theme }) => ({
    "& .MuiSlider-rail": {
      backgroundColor: "#e0e0e0",
    },
    "& .MuiSlider-track": {
      backgroundColor: sliderColor,
    },
    "& .MuiSlider-thumb": {
      backgroundColor: sliderColor,
    },
  }));

  useEffect(() => {
    const audioElement = audioRef.current;
    if (audioElement) {
      audioElement.addEventListener("ended", handleAudioEnded);
      audioElement.addEventListener("timeupdate", handleAudioProgress);
      audioElement.addEventListener("loadedmetadata", handleAudioLoaded);
      return () => {
        audioElement.removeEventListener("ended", handleAudioEnded);
        audioElement.removeEventListener("timeupdate", handleAudioProgress);
        audioElement.removeEventListener("loadedmetadata", handleAudioLoaded);
      };
    }
  }, [audioRef.current]);

  const handleAudioEnded = () => {
    setIsPlaying(false);
    setProgress(0);
    setCurrentTime(0);
  };

  const handleAudioProgress = () => {
    const currentTime = audioRef.current.currentTime;
    // const duration = audioRef.current.duration;
    const progressPercent = (currentTime / duration) * 100;
    setProgress(progressPercent);
    setCurrentTime(currentTime);
  };

  const handleAudioLoaded = () => {
    // const duration = audioRef.current.duration;
    setfileLength(duration);
  };

  const handleTogglePlay = () => {
    setIsPlaying(!isPlaying);
    if (!isPlaying) {
      audioRef.current.play();
    } else {
      audioRef.current.pause();
    }
  };

  const handleProgressChange = (event, newValue) => {
    const currentTime = (newValue / 100) * audioRef.current.duration;
    audioRef.current.currentTime = currentTime;
    setProgress(newValue);
    setCurrentTime(currentTime);
  };

  const handleRedoClick = () => {
    redoFunction();
  };

  const handleSaveClick = () => {
    handleSave();
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60)
      .toString()
      .padStart(2, "0");
    const seconds = Math.floor(time % 60)
      .toString()
      .padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  return (
    <div
      style={{
        background: "#f5f5f5",
        padding: isSmallScreen ? "8px" : "16px",
        borderRadius: "8px",
        margin: isSmallScreen ? "8px" : "16px",
        width: "100%",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
        {showControl && (
          <IconButton
            onClick={handleTogglePlay}
            style={{
              margin: "0 8px",
              backgroundColor: "green",
              color: "white",
              borderRadius: "50%",
              width: "40px",
              height: "40px",
              boxShadow: "none",
            }}
          >
            {isPlaying ? <Pause /> : <PlayArrow />}
          </IconButton>
        )}
        {!isSmallScreen && (
          <Typography
            variant="body2"
            color="textSecondary"
            style={{ margin: "0 4px" }}
          >
            {formatTime(currentTime)}
          </Typography>
        )}
        <Slider
          value={progress}
          aria-label="audio-progress-slider"
          onChange={handleProgressChange}
          style={{ flex: 1, margin: isSmallScreen ? "0 6px" : "0 10px" }}
          color={sliderColor}
          disabled={true}
        />
        <Typography
          variant="body2"
          color="textSecondary"
          style={{ margin: "0 4px" }}
        >
          {formatTime(duration)}
        </Typography>

        <IconButton onClick={handleRedoClick} style={{ marginLeft: "8px" }}>
          <Delete />
        </IconButton>
        <audio ref={audioRef} src={audioFile} />
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
        {!showControl && (
          <Button
            onClick={handleTogglePlay}
            startIcon={isPlaying ? <Pause /> : <PlayArrow />}
            style={{
              backgroundColor: "#1976d2",
              color: "#fff",
              width: "50%",
              marginTop: "16px",
            }}
          >
            {isPlaying ? "Pause" : "Play"}
          </Button>
        )}
        {showSave && (
          <Button
            onClick={handleSaveClick}
            startIcon={<Save />}
            style={{
              backgroundColor: "#1976d2",
              color: "#fff",
              width: "50%",
              marginTop: "16px",
            }}
          >
            Save
          </Button>
        )}
      </div>
    </div>
  );
};

export default AudioPlayer;
